/**
 * A function that converts a regex to a string for consumption via the `pattern` attribute.
 * @param {String} value the supplied regex pattern
 * @returns a String containing the source text of the regexp object.
 */
export const regexToString = (regex) => regex.source;
//# sourceMappingURL=regex-to-string.js.map